import React, { useState } from 'react';
import './style.scss';
import { useIntl } from 'react-intl';
import KCSModal from 'components/Modal/KCSModal';
import Login from 'pages/Login/Login';
import ConfirmPaymentModal from 'components/Modal/ConfirmPaymentModal';

const DataCard = ({ item, customClass, onRegister, isActivate, onUnregister }) => {
  const [openPopupUnReg, setOpenPopupUnReg] = useState(false);
  const [openPopupPayment, setOpenPopupPayment] = useState(false);
  const [openModalLogin, setOpenModalLogin] = useState(false);
  // const [openConfirmLogin, setOpenConfirmLogin] = useState(false);

  const mobile = localStorage.getItem('mobile');
  const intl = useIntl();

  const convertTime = () => {
    switch (item.PERIOD) {
      case "1":
        return intl.formatMessage({ id: 'IDS_TV_DATE' });
      case "2":
        return intl.formatMessage({ id: 'IDS_TV_WEEK' });
      case "3":
        return intl.formatMessage({ id: 'IDS_TV_MONTH' });
      case "4":
        return intl.formatMessage({ id: 'IDS_TV_TIME' });
      case "5":
        return `6 ${intl.formatMessage({ id: 'IDS_TV_MONTH' })}`;
      case "7":
        return `3 ${intl.formatMessage({ id: 'IDS_TV_DATE' })}`;
      case "8":
        return `10 ${intl.formatMessage({ id: 'IDS_TV_DATE' })}`;
      case "9":
        return `9 ${intl.formatMessage({ id: 'IDS_TV_MONTH' })}`;
      case "10":
        return `3 ${intl.formatMessage({ id: 'IDS_TV_DATE' })}`;
      case "11":
        return `3 ${intl.formatMessage({ id: 'IDS_TV_DATE' })}`;
      case "12":
        return `3 ${intl.formatMessage({ id: 'IDS_TV_DATE' })}`;
      case "13":
        return `3 ${intl.formatMessage({ id: 'IDS_TV_DATE' })}`;
      case "14":
        return `3 ${intl.formatMessage({ id: 'IDS_TV_DATE' })}`;
      default:
        return `10 ${intl.formatMessage({ id: 'IDS_TV_DATE' })}`;
    }
  }

  const handleRegister = () => {
    onRegister(item);
    setOpenPopupPayment(false);
  }

  const handleUnRegister = () => {
    onUnregister(item);
    setOpenPopupUnReg(false);
  }

  const checkLogin = () => {
    if (!localStorage.getItem('mobile')) {
      setOpenModalLogin(true);
    } else if (isActivate) {
      setOpenPopupUnReg(true);
    } else {
      setOpenPopupPayment(true);
    }
  }

  // const handleLogin = () => {
  //   setOpenModalLogin(true);
  //   setOpenConfirmLogin(false);
  // }

  return (
    <>
      <div key={item.ID} className={`data-card ${customClass || ''}`}>
        <div className="data-card__image">
          <img alt={item.NAME} src={item.IMAGE_URL} />
        </div>
        <div className="data-card__content">
          <div className="data-card__header">
            <span>{item.NAME}</span>
            <span>{item.PRICE} đ/{convertTime()}</span>
          </div>

          <div className="data-card__body">
            <div className="data-card__des" dangerouslySetInnerHTML={{ __html: item.DESCRIPTION }} />
            <div className="display-center">
              <button onClick={checkLogin}>
                {!isActivate ? intl.formatMessage({ id: 'IDS_SDANGKY' }) : intl.formatMessage({ id: 'IDS_SHUYDV' })}
              </button>
            </div>
          </div>
        </div>
      </div>
      <KCSModal
        isOpenModal={openPopupUnReg}
        closeModal={() => setOpenPopupUnReg(false)}
        title={intl.formatMessage({ id: 'IDS_UNREGISTER_PACKAGE_CONFIRM' })}
        content={`${item.CODE} ${intl.formatMessage({ id: 'IDS_FOR_SUBSCRIBER' })} ${mobile}`}
        confirmButton={intl.formatMessage({ id: 'IDS_TV_DONG_Y' })}
        closeButton={intl.formatMessage({ id: 'IDS_VPLUS_OTP_CANCEL' })}
        confirmAction={handleUnRegister}
      />

      {openPopupPayment &&
        <ConfirmPaymentModal
          item={item}
          isOpenModal={openPopupPayment}
          closeModal={() => setOpenPopupPayment(false)}
          confirmAction={handleRegister}
        />
      }

      {/* <KCSModal
        isOpenModal={openConfirmLogin}
        closeModal={() => setOpenConfirmLogin(false)}
        title={intl.formatMessage({ id: 'IDS_TV_NOTIFICATION' })}
        content={intl.formatMessage({ id: 'IDS_TV_EXPLAIN_LOGIN' })}
        confirmButton={intl.formatMessage({ id: 'IDS_TV_SIGN_IN' })}
        closeButton={intl.formatMessage({ id: 'IDS_VPLUS_OTP_CANCEL' })}
        confirmAction={handleLogin}
      /> */}

      {openModalLogin &&
        <Login
          isOpenModalLogin={openModalLogin}
          closeModalLogin={() => setOpenModalLogin(false)}
          showDes
        />
      }
    </>
  );
}

export default React.memo(DataCard);
